import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

// Ambos tamaños reciben el mismo resultado de itemsVisibles; aquí no se deciden permisos.
export default function AppSidebar({ groups, pathname, onNavigate }) {
    return (
        <nav aria-label="Secciones" className="min-h-0 flex-1 space-y-4 overflow-y-auto p-3">
            {groups.map(group => <section key={group.title}>
                <h3 className="mb-2 px-4 text-[10px] font-semibold uppercase tracking-wider text-secondary-400 dark:text-secondary-500">{group.title}</h3>
                <div className="space-y-1">
                    {group.items.map(item => {
                        const Icon = item.icon;
                        const active = pathname === item.to || pathname.startsWith(`${item.to}/`)
                            || (item.to === '/rules' && (pathname === '/flow-editor' || pathname.startsWith('/flow-editor/')));
                        const content = <>
                            <Icon size={20} aria-hidden="true" className={`shrink-0 ${item.disabled ? 'text-gray-400 dark:text-gray-600' : active ? 'text-white' : 'text-secondary-500 group-hover:text-purple-600 dark:group-hover:text-purple-400'}`} />
                            <span className="min-w-0 flex-1">{item.label}</span>
                            {item.isNew && <span className={`h-2 w-2 shrink-0 rounded-full ${item.disabled ? 'bg-gray-400 dark:bg-gray-600' : 'bg-warning-500'}`} aria-label="Nuevo" />}
                        </>;
                        const classes = `group flex items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium focus-visible:outline-purple-500 ${item.disabled
                            ? 'cursor-not-allowed text-gray-400 opacity-40 dark:text-gray-600'
                            : active ? 'bg-gradient-to-r from-purple-500 to-indigo-600 text-white shadow-lg shadow-purple-500/25'
                                : 'text-secondary-600 hover:bg-secondary-100 hover:text-purple-600 dark:text-secondary-300 dark:hover:bg-secondary-700/50 dark:hover:text-purple-400'}`;
                        return item.disabled
                            ? <span key={item.to} role="link" aria-disabled="true" aria-current={active ? 'page' : undefined} className={classes}
                                title={item.requiresPro ? 'Requiere Plan PRO o superior' : 'Renueva tu suscripción para acceder'}>{content}<span aria-hidden="true" className="text-xs text-red-500">🔒</span></span>
                            : <Link key={item.to} to={item.to} aria-current={active ? 'page' : undefined} onClick={onNavigate} className={classes}>
                                {content}{active && <ChevronRight size={16} aria-hidden="true" className="shrink-0 text-white" />}
                            </Link>;
                    })}
                </div>
            </section>)}
        </nav>
    );
}
